import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

const skillsData = {
  2026: [
    { name: "Figma", date: "15 May 2025", percent: 95, color: "#f97316" },
    { name: "HTML", date: "12 May 2025", percent: 85, color: "#22c55e" },
    { name: "CSS", date: "12 May 2025", percent: 70, color: "#a855f7" },
    { name: "Wordpress", date: "15 May 2025", percent: 61, color: "#3b82f6" },
    { name: "Javascript", date: "13 May 2025", percent: 58, color: "#111827" }
  ],
  2025: [
    { name: "Figma", date: "10 Apr 2024", percent: 90, color: "#f97316" },
    { name: "HTML", date: "02 Apr 2024", percent: 80, color: "#22c55e" },
    { name: "CSS", date: "02 Apr 2024", percent: 65, color: "#a855f7" },
    { name: "Wordpress", date: "05 Apr 2024", percent: 55, color: "#3b82f6" },
    { name: "Javascript", date: "01 Apr 2024", percent: 50, color: "#111827" }
  ],
  2024: [
    { name: "Figma", date: "15 Mar 2023", percent: 85, color: "#f97316" },
    { name: "HTML", date: "10 Mar 2023", percent: 75, color: "#22c55e" },
    { name: "CSS", date: "10 Mar 2023", percent: 60, color: "#a855f7" },
    { name: "Wordpress", date: "12 Mar 2023", percent: 50, color: "#3b82f6" },
    { name: "Javascript", date: "08 Mar 2023", percent: 45, color: "#111827" }
  ]
};

export default function MySkillsCard() {

  const [year, setYear] = useState("2026");
  const skills = skillsData[year];

  return (

<Card className="skills-card w-100">

<Card.Header className="d-flex justify-content-between align-items-center card-header-custom">

<h5 className="mb-0">My Skills</h5>

<Dropdown>

<Dropdown.Toggle className="year-btn">

<FiCalendar className="me-1"/> {year}

</Dropdown.Toggle>

<Dropdown.Menu align="end">

{Object.keys(skillsData).map((y)=>(
<Dropdown.Item key={y} onClick={()=>setYear(y)}>
{y}
</Dropdown.Item>
))}

</Dropdown.Menu>

</Dropdown>

</Card.Header>


<Card.Body>

{skills.map((skill,i)=>{

const radius = 22;
const circumference = 2 * Math.PI * radius;
const offset = circumference - (skill.percent / 100) * circumference;

return(

<div key={i} className="skill-item">

<div className="skill-left">

<span
className="skill-line"
style={{background:skill.color}}
></span>

<div>

<h6 className="skill-title">{skill.name}</h6>

<p className="skill-date">
Updated : {skill.date}
</p>

</div>

</div>

<div className="progress-circle">

<svg width="50" height="50">

<circle
cx="25"
cy="25"
r={radius}
stroke="#e5e7eb"
strokeWidth="4"
fill="none"
/>

<circle
cx="25"
cy="25"
r={radius}
stroke={skill.color}
strokeWidth="4"
fill="none"
strokeDasharray={circumference}
strokeDashoffset={offset}
strokeLinecap="round"
transform="rotate(-90 25 25)"
/>

</svg>

<span className="percent-text">
{skill.percent}%
</span>

</div>

</div>

)

})}

</Card.Body>


<style>{`

.skills-card{
border-radius:5px;
border:2px solid #e5e7eb;
}

  .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}
.year-btn{
border:1px solid #e5e7eb;
background:#fff !important;
font-size:14px;
}

.year-btn:hover{
color:#f97316;
}

.skill-item{
border:1px dashed #e5e7eb;
border-radius:8px;
padding:4px 7px;
margin-bottom:9px;
display:flex;
align-items:center;
justify-content:space-between;
background:#fafafa;
}

.skill-left{
display:flex;
align-items:center;
}

.skill-line{
width:4px;
height:34px;
border-radius:4px;
margin-right:12px;
}

.skill-title{
font-size:16px;
margin:0;
font-weight:600;
color:#1f2937;
}

.skill-date{
font-size:13px;
color:#6b7280;
margin:2px 0 0 0;
}

.progress-circle{
position:relative;
width:50px;
height:50px;
display:flex;
align-items:center;
justify-content:center;
}

.percent-text{
position:absolute;
font-size:12px;
font-weight:600;
color:#374151;
}

`}</style>

</Card>

  );

}